import { render, staticRenderFns } from "./ProtocoloDetalles.vue?vue&type=template&id=1cda2fdb&"
import script from "./ProtocoloDetalles.vue?vue&type=script&lang=js&"
export * from "./ProtocoloDetalles.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloDetalles.vue?vue&type=style&index=0&id=1cda2fdb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports